"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chainDynamicValue = chainDynamicValue;

var _DynamicValue = require("./DynamicValue");

var _FormValue = require("./FormValue");

function chainDynamicValue($value, key) {
  if ($value instanceof _FormValue.FormValue) {
    const pureTouched = $value.touched;
    const {
      touch,
      touched
    } = pureTouched && typeof pureTouched === "object" ? {
      touched: pureTouched[key],
      touch: newValue => {
        const newTouched = { ...pureTouched
        };
        newTouched[key] = newValue;
        $value.touch(newTouched);
      }
    } : {
      touched: false,
      touch: newValue => {
        const newTouched = {};
        newTouched[key] = newValue;
        $value.touch(newTouched);
      }
    };
    return new _FormValue.FormValue($value.value[key], function (newInner) {
      $value.change({ ...$value.value,
        [key]: newInner
      });
    }, touched, touch, $value.error && $value.error[key], $value.showErrors, $value.setShowErrors);
  }

  if ($value instanceof _DynamicValue.DynamicValue) {
    return new _DynamicValue.DynamicValue($value.value[key], function (newInner) {
      $value.change({ ...$value.value,
        [key]: newInner
      });
    });
  }
}
//# sourceMappingURL=chainDynamicValue.js.map